import React, { Component } from 'react';
import Callout from './Callout';

class Box extends Component {
  constructor(props) {
    super(props);
    this.state = {
      callouts: []
      , loading: false
      , boxName: '#box_' + new Date().getTime().toString()
      , minimizado: this.props.minimizado
    };
    this.hideCallout = this.hideCallout.bind(this);
    this.showCallout = this.showCallout.bind(this);
    this.toggleBox = this.toggleBox.bind(this);
    this.toggleLoading = this.toggleLoading.bind(this);
  }

  clearCallouts(callback) {
    this.setState({ callouts: [] }, callback);
  }

  hideCallout(data) {
    let callouts = this.state.callouts;
    callouts.splice(callouts.indexOf(data), 1);
    this.setState({ callouts: callouts });
  }

  showCallout(data) {
    let callouts = this.state.callouts;
    callouts.push(data);
    this.setState({ callouts: callouts });
  }

  toggleLoading(callback) {
    this.setState({ loading: !this.state.loading }, callback);
  }
  
  toggleBox() {
    this.setState({ minimizado: !this.state.minimizado });
  }

  renderTitulo() {
    if (this.props.accordion) {
      return (
        <h3 className="box-title">
          <a className="link-unstyled" style={{ cursor: 'pointer' }} onClick={this.toggleBox}>
            {this.props.titulo || ''}
          </a>
        </h3>
      );
    }
    return (<h3 className="box-title">{this.props.titulo || ''}</h3>);
  }

  renderLoadingOverlay() {
    return (
      <div className="overlay">
        <i className="fa fa-refresh fa-spin"></i>
      </div>
    );
  }

  renderCallouts() {
    if (this.state.callouts.length > 0) {
      return this.state.callouts.map((response, key) => {
        return (<Callout key={key} data={response} onHide={this.hideCallout} />);
      });
    }
  }

  render() {
    return (
      <div className={'box box-' + (this.props.tipo || 'default') + (this.state.minimizado ? ' collapsed-box' : '')}>
        <div className="box-header">
          {this.renderTitulo()}
          <div className="box-tools pull-right">
            <button type="button" className="btn btn-box-tool" onClick={this.toggleBox}><i className={'fa fa-' + (this.state.minimizado ? 'plus' : 'minus')}></i></button>
          </div>
        </div>
        <div className="box-body">
          {this.renderCallouts()}
          {this.props.children}
        </div>
        {this.state.loading && this.renderLoadingOverlay()}
      </div>
    );
  }
}

export default Box;


// WEBPACK FOOTER //
// ./src/modulos/componentes/Box.js